module.exports = __webpack_public_path__ + "static/media/background.d340510d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/background.jpg
// module id = 175
// module chunks = 0